export default "__VITE_ASSET__Bkmm4bKu__"